import React from "react";
import HomeSlider from "../components/HomeSlider";
import HomeProduction from "../components/HomeProduction";
import MissionVision from "../components/MissionVision";
import HomeCorporationValue from "../components/HomeCorporationValue";
import Buyers from "../components/Buyers";
import ValuePropositions from "../components/ValuePropositions";
import QuickContactBanner from "../components/QuickContactBanner";
import PopularQuestions from "../components/PopularQuestions";

const Home = () => {
  return (
    <section>
      <HomeSlider />
      <div>
        <HomeProduction />
        <MissionVision />
        <HomeCorporationValue />
        <Buyers />
        <ValuePropositions />
        <QuickContactBanner />
        <PopularQuestions />
      </div>
    </section>
  );
};

export default Home;
